import { render } from "./DecorationLifecycleChip.vue?vue&type=template&id=5e6740a1&scoped=true"
import script from "./DecorationLifecycleChip.vue?vue&type=script&lang=js"
export * from "./DecorationLifecycleChip.vue?vue&type=script&lang=js"

import "./DecorationLifecycleChip.vue?vue&type=style&index=0&id=5e6740a1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6740a1"]])

export default __exports__